/** @format */
import gsap from 'gsap';
import { useRef } from 'react';
import classNames from 'classnames';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import Typography from '../../../elements/Typography';
import useAppContext from '../../../hooks/useAppContext';
import myImage from '../../../../assets/my-image-png.png';
import batmanImage from '../../../../assets/batman.png';
import scrollDownImg from '../../../../assets/scroll-down.png';
import styles from './profile.module.css';
import { SOCIAL_LINKS } from '../../../../constants/commons';
function Index() {
  const { headerHeight, viewportHeight } = useAppContext();

  function handleAnimation() {
    const tl = gsap.timeline();

    tl.fromTo(
      '.personal-wrapper',
      { xPercent: 100 },
      { xPercent: 0, duration: 2 }
    )
      .fromTo(
        '.my-image',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, delay: 1 }
      )
      .from(['.name', '.jobtitle'], {
        xPercent: 100,
        opacity: 0,
        stagger: 1,
      });

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      animation: tl,
      trigger: '.profile-section',
      start: `top ${headerHeight}`,
      end: `bottom ${headerHeight}`,
      pin: true,
      scrub: true,
      anticipatePin: 1,
      snap: 1,
      markers: false,
    });
  }

  useGSAP(() => {
    handleAnimation();
  });
  return (
    <div
      style={{ height: '100vh' }}
      className={classNames(styles['profile-section'], 'profile-section')}
    >
      <ProfileHero />
      <PersonalDetails />
    </div>
  );
}

function ProfileHero() {
  const heroTitleRef = useRef(null);
  useGSAP(() => {
    gsap.from(['.experience-duration', heroTitleRef.current], {
      duration: 1,
      y: -150,
      opacity: 0,
      ease: 'power4.in',
      onComplete: () => {
        heroTitleRef.current.classList.add(styles['white-flash-bg']);
      },
      stagger: 0.5,
    });
  });
  return (
    <section className={classNames(styles['hero-wrapper'], 'hero-wrapper')}>
      <div className={styles['hero-content']}>
        <img
          alt="batman logo"
          src={batmanImage}
          className={styles['batman-img']}
        ></img>
        <Typography
          as="h1"
          ref={heroTitleRef}
          className={classNames(styles['hero-title'])}
        >
          ReactJS, NodeJS
        </Typography>
        <Typography
          as="p"
          className={classNames(
            styles['experience-duration'],
            'experience-duration'
          )}
        >
          Two years of enterprise experience.
        </Typography>
        <Typography
          as="a"
          href="https://drive.google.com/uc?export=download&id=1FvP56pb2Cx9Cqq41Q83wIufk8877iD4M"
          download="Yogesh_Kakde_Resume.pdf"
          className={classNames(styles['download-resume'], 'download-resume')}
        >
          Download Resume 📋
        </Typography>
        <SocialLinks />
      </div>
    </section>
  );
}

function SocialLinks() {
  const socialLinks = Object.keys(SOCIAL_LINKS);
  return (
    <div className={classNames(styles['social-links'])}>
      {socialLinks.map((platform) => (
        <a
          key={platform}
          href={SOCIAL_LINKS[platform].link}
          target="_blank"
          rel="noreferrer"
          className={classNames(styles['social-link'])}
        >
          <img
            alt={platform}
            src={SOCIAL_LINKS[platform].img}
            className={classNames(styles['social-icon'])}
          ></img>
        </a>
      ))}
    </div>
  );
}
function PersonalDetails() {
  function handleAnimation() {
    const timeline = gsap.timeline();

    timeline.to('.silent-debugger', {
      y: '150vh',
      onUpdate: function () {
        const silentDebugger = document.querySelector('.silent-debugger');
        const myDetails = document.querySelector('.details');
        const silentDebuggerRect = silentDebugger.getBoundingClientRect();
        const myDetailsRect = myDetails.getBoundingClientRect();

        if (
          silentDebuggerRect.bottom >= myDetailsRect.top &&
          silentDebuggerRect.top <= myDetailsRect.bottom
        )
          myDetails.style.opacity = 0;
        else myDetails.style.opacity = 1;
      },
    });

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.personal-wrapper',
      start: 'bottom top',
      end: '+=2000',
      scrub: 0.2,
      markers: false,
    });
  }
  useGSAP(() => {
    handleAnimation();
  });
  return (
    <section
      className={classNames(styles['personal-wrapper'], 'personal-wrapper')}
    >
      <div className={classNames(styles['silent-debugger-prt'])}>
        <Typography
          className={classNames(styles['silent-debugger'], 'silent-debugger')}
        >
          Silent Debugger
        </Typography>
      </div>
      <div className={classNames(styles['details'], 'details')}>
        <Typography as="p" className={classNames(styles['name'], 'name')}>
          Yogesh K. Kakde
        </Typography>
        <Typography
          as="p"
          className={classNames(styles['jobtitle'], 'jobtitle')}
        >
          MERN DEVELOPER
        </Typography>
      </div>
      <div className={classNames(styles['img-container'])}>
        <img className="my-image" alt="Yogesh Kakde" src={myImage}></img>
      </div>
      <div className={classNames(styles['scroll-down'], 'scroll-down')}>
        <img alt="scroll down" src={scrollDownImg}></img>
        <Typography as="p" className={classNames(styles['scroll-text'])}>
          Scroll Down
        </Typography>
      </div>
    </section>
  );
}

export default Index;
